import { render, staticRenderFns } from "./uretim.vue?vue&type=template&id=f5e3b936&scoped=true&"
import script from "./uretim.vue?vue&type=script&lang=js&"
export * from "./uretim.vue?vue&type=script&lang=js&"
import style0 from "./uretim.vue?vue&type=style&index=0&id=f5e3b936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e3b936",
  null
  
)

export default component.exports